// Test features instead of assuming capabilities from a browser name.
export function canRenderEnvironment(platform = globalThis) {
  if (platform.location?.hash === '#simple-view') return false;
  if (new URLSearchParams(platform.location?.search || '').get('view') === 'static') return false;
  if (!platform.document || !platform.ResizeObserver || !platform.Worker) return false;
  try {
    const canvas = platform.document.createElement('canvas');
    const gl = canvas.getContext('webgl2', { failIfMajorPerformanceCaveat: false });
    if (!gl) return false;
    // The reflection/bloom pipeline needs renderable half-float targets.
    const supported = Boolean(gl.getExtension('EXT_color_buffer_float') || gl.getExtension('EXT_color_buffer_half_float'));
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return supported;
  } catch { return false; }
}

export function listenMediaQuery(media, listener) {
  if (media.addEventListener) {
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }
  media.addListener(listener);
  return () => media.removeListener(listener);
}

export function audioContextConstructor(platform = globalThis) {
  return platform.AudioContext || platform.webkitAudioContext || null;
}
